import { render, staticRenderFns } from "./keyboard_doc.vue?vue&type=template&id=1e6fed2a&scoped=true"
import script from "./keyboard_doc.vue?vue&type=script&lang=js"
export * from "./keyboard_doc.vue?vue&type=script&lang=js"
import style0 from "./keyboard_doc.vue?vue&type=style&index=0&id=1e6fed2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fed2a",
  null
  
)

export default component.exports